module.exports = __webpack_public_path__ + "static/img/platform-name-s.0eced9f5.png";